module.exports = __webpack_public_path__ + "static/media/rm_06-20.12731518.png";